<script>

export default {
  name: 'alert-no-covenant'
}
</script>

<template lang="pug">
  .alert.alert-danger.alert-dismissable.fade.in(style="color: red")
    button.close(type='button', data-dismiss='alert', aria-label='close')
      span(aria-hidden='true') ×
    strong
    | Este profissional não atende ao convênio selecionado.  &nbsp;
    | Selecione a opção &nbsp;
    strong particular &nbsp;
    | para confirmar sua consulta.
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/form/components/alert/alert-covenant-not-exist.vue